module.exports = __webpack_public_path__ + "img/fj.7e97c105.svg";